import React from 'react';
import { Link } from 'react-router-dom';
import { useHomeCustomizationStore } from './EditableScene/store';

type HomePageLink = {
  id: number,
  isInternal: boolean,
  link: string,
  name: string,
  ordering: number,
};

type HomePageGroup = {
  id: number,
  name: string,
  ordering: number,
  homePageLinks: HomePageLink[],
};

export default function HomeLink({ data }: { data: HomePageGroup[] }) {
  const { toggleEditMode } = useHomeCustomizationStore();
  if (!data.length) {
    return (
      <div>
        <span>
          Nothing here. Try to{' '}
          <a href="#" onClick={toggleEditMode}>
            Modify the Home Page
          </a>
        </span>
      </div>
    );
  }
  return (
    <div className="space-y-2">
      {data.map(group => {
        return (
          <div key={group.id}>
            <p>
              <b>{group.name}</b>
            </p>
            <ul>
              {group.homePageLinks.map(link => {
                return (
                  <li key={link.id}>
                    {link.isInternal ? (
                      <Link to={link.link}>{link.name}</Link>
                    ) : (
                      <a href={link.link} target="_blank">
                        {link.name}
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
